export default __webpack_public_path__ + "static/media/Blade's Boots of Shattered Souls.659a5a45.jpg";